import React from 'react';
import { Navigate } from 'react-router-dom';

/** 舊主管頁：改導向統一主頁（依登入角色顯示） */
export default function ShiftManagerHome() {
  return <Navigate to="/shift/home" replace />;
}
